import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { debounce } from "lodash";
import { createGTExHeatmap } from "./createGTExHeatmap";

const GTExHeatmap = (props) => {
  const { heatmapData, uniqueKey } = props;
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(null);

  const handleResize = debounce(() => {
    if (containerRef?.current?.clientWidth > 450) {
      setContainerWidth(containerRef?.current?.clientWidth);
    }
  }, 300);

  useEffect(() => {
    createGTExHeatmap(heatmapData, uniqueKey, containerWidth);
  }, [heatmapData, uniqueKey, containerWidth]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (heatmapData) {
      setContainerWidth(containerRef.current.clientWidth);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [heatmapData, uniqueKey]);

  if (heatmapData) {
    return (
      <div
        className="tw-w-full tw-overflow-x-auto"
        id={`GTEx_Heatmap_${uniqueKey}`}
        ref={containerRef}
      >
        <svg />
      </div>
    );
  }
  return null;
};

GTExHeatmap.propTypes = {
  heatmapData: PropTypes.arrayOf(
    PropTypes.shape({
      exon: PropTypes.string,
      value: PropTypes.number,
      x: PropTypes.string,
      y: PropTypes.string,
    })
  ),
  uniqueKey: PropTypes.number,
};

GTExHeatmap.defaultProps = {
  heatmapData: null,
  uniqueKey: "",
};

export default GTExHeatmap;
